var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Boxed/Grey Light ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Print-styles",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A4---Page-1",
    transform: "translate(-456.000000, -364.000000)",
    fill: "#BCEDC3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(33.000000, 260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(68.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Boxed/Grey-Light-",
    transform: "translate(355.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9,2.175 C2.49959356,2.175 2.175,2.49959356 2.175,2.9 L2.175,26.1 C2.175,26.5004064 2.49959356,26.825 2.9,26.825 L26.1,26.825 C26.5004064,26.825 26.825,26.5004064 26.825,26.1 L26.825,2.9 C26.825,2.49959356 26.5004064,2.175 26.1,2.175 L2.9,2.175 Z M2.9,0 L26.1,0 C27.7016258,-2.94213882e-16 29,1.29837423 29,2.9 L29,26.1 C29,27.7016258 27.7016258,29 26.1,29 L2.9,29 C1.29837423,29 1.96142588e-16,27.7016258 0,26.1 L0,2.9 C-1.96142588e-16,1.29837423 1.29837423,2.94213882e-16 2.9,0 Z",
    id: "Rectangle-3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5399704,21.2895659 C12.9385064,21.2686796 13.3290744,21.0957568 13.6172114,20.7757483 L22.7994491,10.5778402 C23.375723,9.93782325 23.324049,8.95182474 22.684032,8.37555089 C22.0440151,7.79927704 21.0580166,7.85095104 20.4817427,8.49096798 L12.3429411,17.5300229 L8.4028402,13.9823402 C7.76282325,13.4060663 6.77682474,13.4577403 6.20055089,14.0977573 C5.62427704,14.7377742 5.67595104,15.7237727 6.31596798,16.3000466 L11.4149221,20.8911654 C11.7349305,21.1793024 12.1414344,21.3104523 12.5399704,21.2895659 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksCheckmark);
export default __webpack_public_path__ + "static/media/tasks-checkmark.ab2d451502e6e4f6d47dfc23eb51ec95.svg";
export { ForwardRef as ReactComponent };